import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps, TreeSelect, TreeSelectProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { SaveTicketValues } from "../..";
import { useIssueCategoryTreeSelectData } from "../../../issue/hooks/useIssueCategoryTreeData";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { useSaveConfigManager } from "../../hooks/useSaveConfigManager";

type Props = FormItemProps<SaveTicketValues> & TreeSelectProps<string>;

export const IssueInput = observer((props: Props) => {
  const t = useTranslation();
  const [issues, _, __, loading] = useIssueCategoryTreeSelectData();
  const config = useFieldConfig("issuecategory");
  const manager = useSaveConfigManager();

  useEffect(() => {
    if (!manager) return;
    manager.registerPreperation("issuecategory");
    if (!loading) {
      manager.markFieldPrepared("issuecategory");
    }
  }, [loading, manager]);

  if (config && !config.hidden && issues.length === 0) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.issue.label");

  return (
    <Form.Item<SaveTicketValues>
      name="issuecategory"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.issuecategory.error.empty"),
        },
      ]}
      {...props}
    >
      <TreeSelect
        treeData={issues}
        style={{ minWidth: 150 }}
        allowClear
        showSearch
        treeNodeFilterProp="title"
        placeholder={t("maintenance:ticket.create.issuecategory.placeholder")}
        size="small"
        {...props}
      />
    </Form.Item>
  );
});
